import { ReactNode } from 'react';
import Form from '../form/Form';
import Description from '../typography/Description';
import Modal from './Modal';

const ConfirmModal: React.FC<ConfirmModalProps> = ({
    closeModal,
    handleSubmit,
    error,
    isPosting,
    title = 'Confirm',
    description = 'Are you sure?',
    isDelete,
}) => {
    return (
        <Modal closeModal={closeModal} title={title} size="small">
            <Description>{description}</Description>
            <Form
                onSubmit={handleSubmit}
                onCancel={closeModal}
                isPosting={isPosting}
                isDelete={isDelete}
            />
        </Modal>
    );
};
interface ConfirmModalProps {
    closeModal: () => void;
    handleSubmit: () => void;
    error?: string | null;
    isPosting?: boolean;
    title?: string;
    description?: ReactNode;
    isDelete?: boolean;
}

export default ConfirmModal;
